export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy41N2I3NjRmNS01NTlmLTQ1OTItOTNhMy00ZGIyMDY3YWI2MWMucG5nIjs="